import { V2CreateConsumptionReportApiResponse } from "@generated";
import { BucketSize, ConsumptionReport } from "./types";

export const normalizeConsumptionReport = (
  response?: V2CreateConsumptionReportApiResponse
): ConsumptionReport => {
  const attrs = response?.data?.attributes;
  const overdraft = attrs?.overdraft;
  return {
    // Only explicitly `false` means "not provisioned"; absence (no data yet)
    // is treated as available so the empty/spinner states own that case.
    available: attrs?.available !== false,
    startingBalance: attrs?.["total-credits-purchased"] ?? 0,
    currentBalance: attrs?.["current-balance"] ?? 0,
    provisionedBalance: attrs?.["provisioned-balance"] ?? 0,
    totalConsumed: attrs?.["total-credits-consumed"] ?? 0,
    inOverdraft: attrs?.["in-overdraft"] ?? false,
    overdraft: {
      usable: overdraft?.usable ?? 0,
      used: overdraft?.used ?? 0,
      limit: overdraft?.limit ?? null,
      unlimited: overdraft?.unlimited ?? false,
    },
    buckets: (attrs?.buckets ?? []).map((bucket) => ({
      periodStart: bucket["period-start"] ?? "",
      credits: bucket.credits ?? 0,
      endingBalance: bucket["ending-balance"] ?? 0,
    })),
  };
};

export const defaultStartDate = (today: Date = new Date()): string => {
  const oneYearAgo = new Date(today);
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return oneYearAgo.toISOString().slice(0, 10);
};

export const formatBucketLabel = (
  isoDate: string,
  bucketSize: BucketSize
): string => {
  if (!isoDate) return "";
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  const options: Intl.DateTimeFormatOptions =
    bucketSize === "month"
      ? { year: "numeric", month: "short" }
      : { year: "numeric", month: "short", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
};
